import loadable from '@loadable/component';

export const LazyBrandPage = loadable(
  () =>
    import(
      /* webpackChunkName: "content/catalog/brandpage" */
      '.'
    ),
);
